<template>
  <div class="person-box">
     <v-head :title="title"></v-head>		
     <div class="stepDiv">
        <van-steps active-color="#228ccd" :active="active">
          <van-step>报名会议</van-step>
          <van-step>缴纳会议费</van-step>
          <van-step>申请发票</van-step>
          <van-step>完成</van-step>
        </van-steps>
      </div>
      <div class="content">
        <stepMeeting @sendActive="setActive"  v-if="active === 0"></stepMeeting>
        <stepMeetingPay @sendActive="setActive" v-else-if="active === 1" ></stepMeetingPay>
        <stepMeetingInvoice @sendActive="setActive" v-else-if="active === 2" ></stepMeetingInvoice>
        <stepSuccessed v-else></stepSuccessed>
      </div>
    
  </div>
</template>

<script>
import vHead from "../../../components/Subhead.vue";
import { Step, Steps,Checkbox} from "vant";
import stepMeeting from "./stepMeeting.vue";
import stepMeetingPay from "./meetingPay.vue";
import stepMeetingInvoice from "./invoiceList.vue";
import stepSuccessed from "./successed.vue";
import {getRegisterInfo,getUser} from "@/api/dictionary";

export default {
  data() {
    return {
      active: 0, 
      member: {},
      title:'立即报名'
    };
  },
  components: {
    vHead,
    [Step.name]: Step,
    [Steps.name]: Steps,
    stepMeeting,
    stepMeetingPay,
    stepMeetingInvoice,
    stepSuccessed,
  },
  computed: {
    id() {
	      return this.$route.query && this.$route.query.meetingId;
	    }
  },
  methods: {
    rule() {
      this.$router.push({ name: "rule" });
    },
    setActive(value) {
      this.active = value;
    },
    updateMember(value) {
      this.member = value;
    },
    getUserInfo(){
      getUser().then(res=>{
        if (res.success) {
          this.userInfo = res.result;
          getRegisterInfo({memberId:this.userInfo.id,meetingId:this.id})
            .then(res =>{
                if(res.success){
                  if(res.result.registerStep){
                    this.active = res.result.registerStep;
                  }
        }
    })
        }
      })
	  },
  },
  mounted(){
    this.getUserInfo();
  
  }
};
</script>

<style lang="less" scoped>
.stepDiv{ padding: 20px; }
/deep/.van-nav-bar__text{ color: #000;}
/deep/.van-step--horizontal .van-step__icon{ font-size:16px}
</style>
